module.exports = __webpack_public_path__ + "img/p13.61e2a3af.png";